<script lang="ts">
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import { AI } from "$components/+shared/OVIcon";
</script>

<div
  class="rounded-[3px] bg-[rgba(99,91,255,0.10)] px-[2.5px] py-[1px] leading-none dark:bg-[rgba(137,156,235,0.05)]"
>
  <div
    class="flex items-center gap-0.5 bg-[linear-gradient(0deg,_rgba(255,_255,_255,_0.05),_rgba(255,_255,_255,_0.05)),_linear-gradient(253.22deg,_#A895EF_10.01%,_#899CEB_77.33%)] bg-clip-text"
  >
    <OVIcon icon={AI} class="text-brand-blurple dark:text-[#BAC8FD]" size="size-3.5" />
    <span class="mr-[1px] text-xs text-brand-blurple dark:text-[#BAC8FD]">AI</span>
  </div>
</div>
